export default __webpack_public_path__ + "static/media/sand_dam.a010257e.png";